import { isType } from "./isType";
export function guard(arg) {
    return function (action) { return isType(action, arg); };
}
